import {IMapItemData} from "../../../../interface";
import {SquadMapitem} from "./SquadMapitem";

const ADD_BUTTON_SELECTOR: string = '[data-add-map]';

export class SquadMapcycleUI {
  public constructor(private $base: JQuery) {
  }

  /**
   * Enable save button
   */
  public enableAddButton() {
    this.$base.find(ADD_BUTTON_SELECTOR).removeAttr('disabled');
  }

  /**
   * Enable save button
   */
  public onAddButtonClick(callback: (data: IMapItemData) => void) {
    this.$base.find(ADD_BUTTON_SELECTOR).on('click', (event) => {
      event.preventDefault();

      callback({
        name: this.getMapValue(),
      });

      return false;
    });
  }

  /**
   *
   */
  public onChangeMapRotationMode(callback: () => void) {
    $('[data-name="MapRotationMode"]').on('change', (event) => {
      callback();
    });
  }

  /**
   * read current map value
   */
  public getMapRotationModeValue(): string {
    return $('[data-name="MapRotationMode"]').val() as string;
  }

  /**
   *
   */
  public getMapValue(): string {
    if (this.getMapRotationModeValue().match('^Layer')) {
      return this.getLayerValue();
    } else if (this.getMapRotationModeValue().match('^Level')) {
      return this.getLevelValue();
    }
  }

  /**
   * read current mapLayer value
   */
  public getLayerValue(): string {
    return $('[data-name="layers"]').val() as string;
  }

  /**
   * read current mapLevel value
   */
  public getLevelValue(): string {
    return $('[data-name="levels"]').val() as string;
  }

  /**
   * Render the maps by creating Mapitem instances
   * @param data - array of IMapItemData
   * @param form
   */
  public render(data: IMapItemData[], form: any) {
    if (this.getMapRotationModeValue().match('^Layer')) {
      $('[data-search-value="Layers"]').show();
      $('[data-search-value="Levels"]').hide();
    } else if (this.getMapRotationModeValue().match('^Level')) {
      $('[data-search-value="Layers"]').hide();
      $('[data-search-value="Levels"]').show();
    }

    this.$base.find('.mapcycle__maps').html('');
    return new Promise((resolve) => {
      data.map((map, i) => {
        // Add label from list choices
        let choices = [];
        if (this.getMapRotationModeValue().match('^Layer')) {
          choices = form[0].choices;
        } else if (this.getMapRotationModeValue().match('^Level')) {
          choices = form[1].choices;
        }
        let choice = choices.find(x => x[0] == map.name);
        // If a new map has been added to the game, but hasn't been added to the map choices in the configs management yet,
        // we need to use the map's name as label to avoid a frontend error.
        if (choice !== undefined) {
          map.label = choice[1];
        } else {
          console.info(map.name + ' is missing from configs management');
          map.label = map.name;
        }

        // Add image (layers use the image from their map)
        map.image = map.name;
        if (map.image.search('_')) {
          // Layer name may begin with CAF_
          map.image = map.image.replace(/^CAF_/, '');
          // Layer name has additional info behind the level name
          map.image = map.image.replace(/_.+$/, '');
        }

        return new SquadMapitem({...map, counter: i + 1, index: i}, this.$base);
      });

      resolve();
    })
  }
}
